// Rummy 500 page entry: one game against the computer, saved as you go. No daily (games/Game.daily?).
import { RummyGame } from "../cards/rummy-ui"

const board = document.getElementById("board")
if (board) (window as unknown as { dtGame?: RummyGame }).dtGame = new RummyGame(board)
